export enum NotificationsPaneOpenStatus {
  Uncontrolled = 'Uncontrolled',
  Open = 'Open',
  Closed = 'Closed',
}
